import http from '@root/utils/axios/admin';

let state = {
    GamesIGDBList: [],
}

let actions = {

    fetchGamesIGDBList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/source/games', { params: filter }).then((response) => {
                commit('setGamesIGDBList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    toggleShowGame({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/source/toggle-show-game', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error.response);
            })
        });
    },


}


let mutations = {
    setGamesIGDBList(state, data) {
        state.GamesIGDBList = data;
    },
}

export default {
    state,
    actions,
    mutations
}